var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInterno(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.14 14.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9e021;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 59interno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.07,0a7.07,7.07,0,1,0,7.07,7.07A7.08,7.08,0,0,0,7.07,0ZM9.22,2.93c-.14,0-.31,0-.5,0a2.75,2.75,0,0,0-.51.12.52.52,0,0,0-.35.26,1,1,0,0,0-.09.41v7a.74.74,0,0,0,.1.4.65.65,0,0,0,.34.28,2.41,2.41,0,0,0,.46.12,3.29,3.29,0,0,0,.55.07v.49H4.86v-.49l.53,0a1.87,1.87,0,0,0,.49-.08.71.71,0,0,0,.33-.24.78.78,0,0,0,.1-.43v-7a1,1,0,0,0-.07-.4.68.68,0,0,0-.36-.27A5,5,0,0,0,5.36,3a3.16,3.16,0,0,0-.5-.09V2.45H9.22Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterno);
export default __webpack_public_path__ + "static/media/icon-interno.ed0cc1ab75e7bbdab4837a67652748d4.svg";
export { ForwardRef as ReactComponent };